<template>
    <el-dropdown
    placement="bottom"
    @command="handleCommand"
  >
    <el-avatar
      class="my-avatar"
      :src="profile"
    ></el-avatar>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        icon="el-icon-user-solid"
        :disabled="true"
      >{{userName}}</el-dropdown-item>
      <el-dropdown-item
        command="logout"
        icon="el-icon-setting"
      >退出</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>
<script>
    import profile from "../../../assets/client/profile.png";
    export default{
        data(){
            return {
                userName: this.$store.state.userInfo.usercname,
                profile:profile,
                };
        },
        methods:{
            handleCommand(command){
              switch (command) {
                case "logout":
                  //退出
                  window.sessionStorage.clear();
                  this.$store.commit("saveToken", "");
                  this.$Cookies.remove(process.env.VUE_APP_COOKIES);
                  let to =window.location.protocol +"//" +window.location.host +(window.location.pathname == "/" ? "/" : window.location.pathname) +"#/"; //这里重定向要加后面/#/
                  window.location.href = process.env.VUE_APP_LOGIN_URL + "login?RedirectUrl=" + encodeURIComponent(to) + "&sysid=" + process.env.VUE_APP_SYSID;
                  break;
                default:
                  break;
              }
            },
            getuserInfo()
            {

            }
        }
    }

</script>
<style lang="less" scoped>
.my-avatar {
  cursor: pointer;
  height: 40px;
  width: 40px;
  line-height: 40px;
  size:large;
  color: #8093B3;
  background: #CCCCCC;
}
</style>
